import React from 'react';
import { Box } from '@material-ui/core';

import BaseTopBar from 'components/elements/molecules/TopBar';
import ButtonGoBack from 'components/elements/atoms/ButtonGoBack';
import { APP_PATHS } from 'components/routes/paths';
import { useSelector } from 'react-redux';
import { airportSelectors } from 'store/selectors';
import { useTranslations } from 'components/utilities';

const TopBar = () => {
	const { t } = useTranslations();
	const airportContext = useSelector(airportSelectors.getContext);
	const backLink = APP_PATHS.CARS.replace(':airportSlug', airportContext);

	return (
		<BaseTopBar
			title={t('car.header')}
			actions={
				<Box pl={1}>
					<ButtonGoBack path={backLink} />
				</Box>
			}
			oneLine
		/>
	);
};

export default TopBar;
